module.exports = __webpack_public_path__ + "static/img/se.c385ba82.svg";